import { useCurrentUserQuery } from "@/hooks/user";
import { toRouteError, AppRouteError } from "@/errors/routeError";
import { Outlet } from "react-router";
import { Loading } from "./Loading/Loading";

export function RequireAdmin() {
  const { data, isPending, isError, error } = useCurrentUserQuery();

  if (isPending) return <Loading text="Checking permissions" />;
  if (isError) throw toRouteError(error, { scope: "admin" });
  if (!data?.isAdmin) {
    throw new AppRouteError({ code: "ADMIN_REQUIRED", scope: "admin" });
  }

  return <Outlet />;
}
